var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cardData)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.cardsModel.cards),function(card){return _c('v-flex',{key:card.title,attrs:{"md3":"","sm6":""}},[_c('DashboardStatsCard',{attrs:{"stats":card}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }